module.exports = __webpack_public_path__ + "static/media/marksman.b339ed8f.png";